module.exports = __webpack_public_path__ + "img/logo-wallonie.45258121.png";